import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { BriefHeader } from '../Shared/BriefHeader';
import { BriefDescription } from '../Shared/BriefDescription';
import type { SellerBriefResponse } from '../../types/SellerBriefResponse';
import { BriefStatus } from '../Shared/BriefStatus';
import { AdditionalOptionsMenu } from './AdditionalOptionsMenu';

interface BuyerBriefContentProps {
  brief: SellerBriefResponse;
  onEdit?: () => void;
  onDuplicate?: () => void;
  onDelete?: () => void;
}

export const BuyerBriefContent: React.FC<BuyerBriefContentProps> = ({ brief, onEdit, onDuplicate, onDelete }) => {
  const { id, title, createdAt, customOffersMetrics, status, editDetails } = brief;
  const hasActions = onEdit || onDuplicate || onDelete;

  return (
    <Stack direction="column" gap="10">
      <BriefHeader
        title={title}
        createdAt={createdAt}
        totalCount={customOffersMetrics?.totalCount}
        isEdited={!!editDetails}
        actionsMenu={
          hasActions ? (
            <AdditionalOptionsMenu
              briefId={id}
              briefStatus={status}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
            />
          ) : undefined
        }
      />
      <BriefStatus status={status} />
      <BriefDescription {...brief} scope="buyer" />
    </Stack>
  );
};
